'use strict';
rcGroupByElementRange.$inject = ['$q', 'accountService', 'accountStructureService', 'ACCOUNT_TYPES'];
angular.module('schoolLinqApp').directive('rcGroupByElementRange', rcGroupByElementRange);

function rcGroupByElementRange($q, accountService, accountStructureService, ACCOUNT_TYPES) {
	return {
		require: ['ngModel'],
		scope: {
			ngModel: '=',
		},
		replace: true,
		restrict: 'AE',
		template: require('@ajs/templates/reports/rcGroupByElementRange.html'),
		controller: [
			'$scope',
			'$element',
			'$rootScope',
			function ($scope, $element, $rootScope) {
				$scope.viewModel = {
					elements: [],
				};
				$scope.ngModel = [
					{
						elementsMinMaxList: [],
						rangeRows: [{}],
					},
				];

				$scope.loadingElementRange = $q.all([loadAccountTypes()]);

				function loadAccountTypes() {
					return accountStructureService.getAccountTypes().then(finishLoadingAccountTypes);

					function finishLoadingAccountTypes(response) {
						$scope.viewModel.accountTypes = response.data.accountTypes;

						$scope.viewModel.accountTypes = _.filter(response.data.accountTypes, function (accntType) {
							let retTypes = accntType.Id === ACCOUNT_TYPES.Expense || accntType.Id === ACCOUNT_TYPES.Revenue;
							if ($rootScope.mode === 'sa') {
								retTypes = retTypes || accntType.Id === ACCOUNT_TYPES.Net;
							}
							return retTypes;
						});

						let elementNameList = [];

						for (let idx = 0; idx < $scope.viewModel.accountTypes.length; idx++) {
							let accntType = $scope.viewModel.accountTypes[idx];
							let elements = accntType.ElementMap.split('.');
							let masks = accntType.Mask.split('.');

							for (let i = 0; i < elements.length; i++) {
								let elementName = elements[i].toString();
								let elementItem = _.find($scope.viewModel.elements, function (obj) {
									return obj.Id === elementName;
								});
								if (!elementItem) {
									elementNameList.push(elementName);

									$scope.viewModel.elements.push({
										Index: $scope.viewModel.elements.length,
										Id: elementName,
										Description: elementName,
										MinValue: masks[i],
										MaxValue: masks[i].replace(/0/g, '9'),
										PlaceHolder: masks[i].replace(/0/g, '_'),
									});
								}
							}
						}

						return accountService.getElementsMinMax(elementNameList).then(finishLoadingElementMinMax);
					}

					function finishLoadingElementMinMax(response) {
						$scope.ngModel[0].elementsMinMaxList = response.data.elementsMinMaxList;

						angular.forEach($scope.ngModel[0].elementsMinMaxList, function (e) {
							let elementItem = _.find($scope.viewModel.elements, function (obj) {
								return obj.Id === e.ElementName;
							});
							if (elementItem) {
								elementItem.MinValue = e.MinValue === '' ? elementItem.MinValue : e.MinValue;
								elementItem.MaxValue = e.MaxValue === '' ? elementItem.MaxValue : e.MaxValue;
							}
						});

						var dElement = $scope.ngModel[0].elementsMinMaxList[0];

						var row = {
							ElementIndex: 0,
							RangeOption: 'range',
							FromValue: dElement.MinValue,
							ToValue: dElement.MaxValue,
							SubTotal: true,
						};
						$scope.ngModel[0].rangeRows[0] = row;

						return angular.noop;
					}
				}

				$scope.rangeOptions = [
					{
						displayName: 'range',
						filter: 'range',
					},
					{
						displayName: 'equals',
						filter: 'equals',
					},
				];

				$scope.addRow = function (filter) {
					filter.rangeRows.push({
						ElementIndex: '',
						RangeOption: 'range',
						FromValue: '',
						ToValue: '',
						SubTotal: true,
					});
				};

				$scope.removeRow = function (filter, row) {
					let index = _.findIndex(filter.rangeRows, {
						$$hashKey: row.$$hashKey,
					});
					filter.rangeRows.splice(index, 1);
				};

				$scope.moveRowUp = function (filter, row) {
					let index = _.findIndex(filter.rangeRows, {
						$$hashKey: row.$$hashKey,
					});
					// get the row to move down
					var rowToMoveDown = filter.rangeRows[index - 1];
					filter.rangeRows.splice(index - 1, 1);
					filter.rangeRows.splice(index, 0, rowToMoveDown);
				};

				$scope.moveRowDown = function (filter, row) {
					let index = _.findIndex(filter.rangeRows, {
						$$hashKey: row.$$hashKey,
					});
					// get the row to move up
					var rowToMoveUp = filter.rangeRows[index + 1];
					filter.rangeRows.splice(index + 1, 1);
					filter.rangeRows.splice(index, 0, rowToMoveUp);
				};
			},
		],
	};
}
